// RippleButton.js
import React from "react";

const PlainButton = ({ onClick, isLoading, children, type, disabled, bgColor, work_btn }) => {
    return (
        <button type={type} className={`btn-ripple mbot-btn-secondary center-alignment text-nowrap ${disabled && "bg-disabled"}`} style={{ backgroundColor: bgColor || "", width: work_btn && work_btn == "145px" ? "145px" : work_btn && work_btn == "190px" ? "190px" : "max-content" }} onClick={onClick} disabled={isLoading || disabled}>
            {children}
        </button >
    );
};

export default PlainButton;
